<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 09:24:27
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-11-07 07:28:32
 * @FilePath: /wemeet-admin-new/src/views/aiProduct/aiSentence.vue
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
-->
<template>
  <div>
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-button class="copy_btn" :data-clipboard-text="linkUrl" type="primary" @click="copy($event)">
          复制收录链接
        </el-button>
        <el-button v-if="chooseVal.length > 0" type="success" @click="batchStatus('open')">批量开启</el-button>
        <el-button v-if="chooseVal.length > 0" type="success" @click="batchStatus('close')">批量关闭</el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="AI金句">
            <!-- -->
            <el-switch
              v-model="isShow"
              active-text="开启"
              inactive-text="关闭"
              size="large"
              @change="abstractCloseOrOpenFunc"
            />
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" />
      <el-table-column label="日程" prop="title" show-overflow-tooltip />
      <el-table-column label="时间" show-overflow-tooltip>
        <template #default="{ row }">
          <span v-if="row.startTime && row.endTime">
            {{ handleDate(row.startTime) }} - {{ handleDate(row.endTime) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="isOpenAiAbstractSentence" width="80">
        <template #default="{ row }">
          <!--  -->
          <!-- <el-switch v-model="row.isOpenAiAbstractSentence" size="large" active-text="上线" inactive-text="下线" @change="productStatusChange(row)" /> -->
          <el-tag v-if="row.isOpenAiAbstractSentence" type="success">开启</el-tag>
          <el-tag v-else type="danger">关闭</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作" show-overflow-tooltip width="500">
        <template #default="{ row }">
          <el-button plain type="info" @click="handleEdit(row)">编辑金句</el-button>
          <el-button plain type="info" @click="handleIdea(row)">编辑焦点</el-button>
          <el-button plain type="info" @click="handleAbstract(row)">编辑摘要</el-button>
          <el-button plain type="info" @click="handleRecord(row)">编辑录音</el-button>
          <el-button plain type="danger" @click="handleDel(row)">删除内容</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <!-- <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        /> -->
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <!-- <el-pagination background :current-page="queryForm.pageNum" :layout="layout" :page-size="queryForm.pageSize" :total="total" @current-change="handleCurrentChange" @size-change="handleSizeChange" /> -->

    <EditAiSentence ref="editAISentenceRef" />
    <EditRecord ref="editRecordRef" />
    <EditAbstract ref="editAbstractRef" />
    <EditIdea ref="editIdeaRef" />
  </div>
</template>

<script>
  import {
    defineComponent,
    defineAsyncComponent,
    getCurrentInstance,
    onMounted,
    reactive,
    toRefs,
    onActivated,
    watch,
  } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import {
    abstractGetList,
    abstractCloseOrOpen,
    getAbstractLink,
    batchOpenAbstract,
    batchCloseAbstract,
    abstractClean,
  } from '@/api/ai'
  import { useRoute } from 'vue-router'
  import EditAiSentence from './components/editAiSentence.vue'
  import EditRecord from './components/editRecord.vue'
  import EditAbstract from './components/editAbstract.vue'
  import EditIdea from './components/editIdea.vue'

  import { parseTime, replaceParamVal } from '@/utils/index'
  import { baseAiURL } from '@/config'
  import Clipboard from 'clipboard'
  export default defineComponent({
    name: 'Brand',
    components: {
      EditAiSentence,
      EditRecord,
      EditAbstract,
      EditIdea,
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const route = useRoute()
      const state = reactive({
        queryForm: {
          meetingCode: '',
        },
        isShow: true,
        total: 0,
        listLoading: false,
        list: [],
        layout: 'total, sizes, prev, pager, next, jumper',
        editRef: null,
        previewDialog: null,
        previewQrcode: '',
        previewWebSite: '',
        enterpriseCode: '',
        syncProductRef: null,
        editAISentenceRef: null,
        editRecordRef: null,
        generateWxRef: null,
        tabName: 'product',
        meetingType: '',
        tabList: [
          {
            key: 'product',
            label: '展品管理',
          },
          {
            key: 'type',
            label: '类型管理',
          },
          {
            key: 'attr',
            label: '属性管理',
          },
          {
            key: 'industry',
            label: '行业管理',
          },
          // {
          //   key: 'activeType',
          //   label: '活动类型',
          // },
          // {
          //   key: 'venuesType',
          //   label: '人数规模',
          // },
          // {
          //   key: 'venuesScale',
          //   label: '空间面积',
          // },
        ],
        upLoadRef: null,
        resultRef: null,
        chooseVal: [],
        industryType: '',
        editAbstractRef: null,
        editIdeaRef: null,
        linkUrl: '',
      })

      /**
       * @description: 编辑展商
       * @param {*} row
       * @return {*}
       */
      const handleEdit = (row) => {
        state.editAISentenceRef.handleOpen(row)
      }

      const handleRecord = (row) => {
        state.editRecordRef.handleOpen(row)
      }

      const handleAbstract = (row) => {
        state.editAbstractRef.handleOpen(row)
      }

      const handleIdea = (row) => {
        state.editIdeaRef.handleOpen(row)
      }

      const fetchData = async () => {
        state.listLoading = true
        console.log(route.query, route.params, route, '====>>>')
        state.queryForm.meetingCode = route.query.meetingCode
        state.meetingName = route.query.meetingName
        state.meetingType = route.query.type
        const { data: password } = await getAbstractLink(state.queryForm)
        state.linkUrl = `${baseAiURL}/meeting/recording?meetingCode=${state.queryForm.meetingCode}&password=${password}&meetingName=${state.meetingName}`
        state.isShow =
          route.query.isOpenAiAbstractSentence != 'null' && route.query.isOpenAiAbstractSentence != null
            ? route.query.isOpenAiAbstractSentence == 'true'
              ? true
              : false
            : false
        const { data } = await abstractGetList(state.queryForm)
        data.forEach((v) => {
          v.isOpenAiAbstractSentence =
            v.isOpenAiAbstractSentence != 'null' && v.isOpenAiAbstractSentence != null
              ? v.isOpenAiAbstractSentence
              : false
        })
        state.list = data
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      const handleDate = (val) => {
        return parseTime(val)
      }
      const productStatusChange = async (row) => {
        try {
          let obj = {
            isOpen: row.isOpenAiAbstractSentence,
            sentenceId: row.status,
          }
          await editBrandProductStatus(obj)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        } catch (e) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }
      }

      const abstractCloseOrOpenFunc = async () => {
        try {
          let obj = {
            isOpen: state.isShow,
            meetingCode: state.queryForm.meetingCode,
          }
          await abstractCloseOrOpen(obj)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')

          let url = replaceParamVal('isOpenAiAbstractSentence', state.isShow)
          console.log(url, '====<>>>>>')
          location.href = url
        } catch (e) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }
      }

      onActivated(() => {
        fetchData()
      })

      const handleSelectionChange = (val) => {
        state.chooseVal = val
      }

      const batchStatus = async (status) => {
        console.log(state.chooseVal)
        let params = {
          params: state.chooseVal.map((v) => v.scheduleCode),
        }
        if (status == 'open') {
          await batchOpenAbstract(params)
        } else {
          await batchCloseAbstract(params)
        }

        fetchData()
      }

      const copy = async () => {
        console.log(state.linkUrl)
        var clipboard = new Clipboard('.copy_btn')
        clipboard.on('success', (e) => {
          proxy.$baseMessage(`复制成功`, 'success', 'vab-hey-message-success')
          // 释放内存
          clipboard.destroy()
        })

        clipboard.on('error', (e) => {
          // 不支持复制
          proxy.$baseMessage(`复制失败`, 'success', 'vab-hey-message-success')
          // 释放内存
          clipboard.destroy()
        })
      }

      const handleDel = async (row) => {
        proxy.$baseConfirm(
          '确认要清除所有内容吗？该日程的所有金句、焦点、摘要、录音原文，都会被删除，且不可撤销。',
          null,
          async () => {
            await abstractClean({ scheduleCode: row.scheduleCode })
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          }
        )
      }

      return {
        ...toRefs(state),
        handleEdit,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        productStatusChange,
        Delete,
        Search,
        Plus,
        handleSelectionChange,
        batchStatus,
        handleDate,
        handleRecord,
        handleAbstract,
        handleIdea,
        abstractCloseOrOpenFunc,
        copy,
        handleDel,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
